/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import {
  FilledButton,
  OutlinedButton,
  Spotlight,
  SpotlightTarget,
  Tabs,
  Typography,
  useNeedleTheme,
  useSpotlightContext,
} from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = ({ hasPulse = true }: { hasPulse?: boolean }) => {
  const { themeClassName } = useNeedleTheme();
  const { setIsOpen, setActiveSpotlight } = useSpotlightContext();
  const [tabsValue, setTabsValue] = useState('0');

  const targetId = `test-target-${themeClassName}`;

  return (
    <div className="n-flex n-justify-center n-gap-token-10">
      <FilledButton onClick={() => setActiveSpotlight(targetId)}>
        Activate Spotlight
      </FilledButton>
      <div>
        <Tabs value={tabsValue} onChange={setTabsValue}>
          <SpotlightTarget
            id={targetId}
            hasPulse={hasPulse}
            borderRadius={4}
            indicatorVariant="point"
          >
            <Tabs.Tab id="0">Tab 1</Tabs.Tab>
          </SpotlightTarget>
          <Tabs.Tab id="1">Tab 2</Tabs.Tab>
          <Tabs.Tab id="2">Tab 3</Tabs.Tab>
        </Tabs>
        <Tabs.TabPanel className="n-p-token-4" value={tabsValue} tabId="0">
          <Typography variant="body-medium">Tab 1 content</Typography>
        </Tabs.TabPanel>
        <Tabs.TabPanel className="n-p-token-4" value={tabsValue} tabId="1">
          <Typography variant="body-medium">Tab 2 content</Typography>
        </Tabs.TabPanel>
        <Tabs.TabPanel className="n-p-token-4" value={tabsValue} tabId="2">
          <Typography variant="body-medium">Tab 3 content</Typography>
        </Tabs.TabPanel>
      </div>
      <Spotlight
        placement="bottom-end-top-end"
        target={targetId}
        actions={
          <OutlinedButton
            onClick={() => {
              setIsOpen(false);
              setActiveSpotlight(null);
            }}
          >
            Close
          </OutlinedButton>
        }
      >
        <Spotlight.Header>This is a header</Spotlight.Header>
        <Spotlight.Body>This is content</Spotlight.Body>
      </Spotlight>
    </div>
  );
};

export default Component;
